import React, { useEffect, useRef } from "react";

/* ---------- Skeleton Row ---------- */
const SkeletonRow = ({ colCount }) => (
  <tr>
    {Array.from({ length: colCount }).map((_, i) => (
      <td key={i} className="cc">
        <div className="tw-animate-pulse tw-h-8 tw-bg-gray-200 tw-rounded-md tw-m-1" />
      </td>
    ))}
  </tr>
);

const CommonTable = ({ staticData, chartData, redJodi, renderDate }) => {
  const render = (val) => (renderDate ? renderDate(val) : val);

  const scrollRef = useRef(null);

  const colCount = 8;
  const dynamicLoading = !chartData || chartData.length === 0;

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chartData]);

  const isRedValue = (val) =>
    redJodi.map((j) => parseInt(j)).includes(parseInt(val));

  return (
    <div className="tw-overflow-x-auto">
      <table className="table fw-bold tw-w-full" border="collapse">
        <thead>
           <tr className="tw-text-center">
            <th className="cc tw-text-[10px] md:tw-text-sm tw-text-center tw-sticky tw-left-0 tw-bg-white tw-z-30">
              Date
            </th>

            {["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"].map((day) => (
              <th key={day} className="cc tw-text-[10px] tw-text-center md:tw-text-sm">
                {day}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {/* STATIC */}
          { Object.entries(staticData).map(([week, days], index) => {
                const splitDate = week.split(" ");

                return (
                  <tr key={index}>
                    <td className="cc tw-sticky tw-left-0 tw-bg-white tw-z-10">
                      <div className="pana-chart-main">
                        <span className="tw-text-[8px] md:tw-text-sm tw-text-center tw-block">
                          {render(splitDate?.[0])}
                          <br />
                          {splitDate?.[1]}
                          <br />
                          {render(splitDate?.[2])}
                        </span>
                      </div>
                    </td>

                    {Object.entries(days).map(([day, values], id) => (
                      <td key={id} className="cc">
                        <div className="kalyan-chart-number-black tw-flex tw-justify-center">
                          {(values || []).map((value, valueIndex) => {
                            const isRed = isRedValue(value);
                            return (
                              <span
                                key={valueIndex}
                                className={`cp ${
                                  isRed ? "tw-text-red-600" : "tw-text-black"
                                }`}
                              >
                                {value}
                              </span>
                            );
                          })}
                        </div>
                      </td>
                    ))}
                  </tr>
                );
              })}

          {/* DYNAMIC */}
          {dynamicLoading
            ? Array.from({ length: 4 }).map((_, i) => (
                <SkeletonRow key={`api-${i}`} colCount={colCount} />
              ))
            : chartData.map((item1) => (
                <tr key={item1.id}>
                  <td className="cc tw-sticky tw-left-0 tw-bg-white tw-z-10">
                    <div className="tw-text-[10px] md:tw-text-sm tw-text-center tw-block">
                      {item1.weekStartDay}
                      <br />
                      to
                      <br />
                      {item1.weekEndDay}
                    </div>
                  </td>

                  {(item1.data || []).map((nestedItem) => {
                    const f0 =
                      nestedItem.relatedData?.[0]?.winningDigitFamily ?? "";
                    const f1 =
                      nestedItem.relatedData?.[1]?.winningDigitFamily ?? "";
                    const combined = `${f0}${f1}`;
                    const isRed = isRedValue(combined);

                    return (
                      <td key={nestedItem.id} className="cc">
                        <div className="tw-flex tw-flex-col tw-items-center tw-leading-tight">
                          <span className={isRed ? "tw-text-red-600" : ""}>
                            {nestedItem.relatedData?.[0]?.winningDigit}
                          </span>

                          <span className={isRed ? "tw-text-red-600" : ""}>
                            {combined}
                          </span>

                          <span className={isRed ? "tw-text-red-600" : ""}>
                            {nestedItem.relatedData?.[1]?.winningDigit}
                          </span>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}

          <tr ref={scrollRef} />
        </tbody>
      </table>
    </div>
  );
};

export default CommonTable;
